import $ from "jquery";
import moment from "moment";

var respuesta = [];
export const cmes = (m) => {
  var mes = "";
  switch (m) {
    case 1:
      mes = "ENERO";
      break;
    case 2:
      mes = "FEBRERO";
      break;
    case 3:
      mes = "MARZO";
      break;
    case 4:
      mes = "ABRIL";
      break;
    case 5:
      mes = "MAYO";
      break;
    case 6:
      mes = "JUNIO";
      break;
    case 7:
      mes = "JULIO";
      break;
    case 8:
      mes = "AGOSTO";
      break;
    case 9:
      mes = "SEPTIEMBRE";
      break;
    case 10:
      mes = "OCTUBRE";
      break;
    case 11:
      mes = "NOVIEMBRE";
      break;
    case 12:
      mes = "DICIEMBRE";
      break;
    default:
      mes = "";
      break;
  }
  return mes;
};

export const nmes = (m) => {
  var mes = "";
  switch (m) {
    case "ENERO":
      mes = 1;
      break;
    case "FEBRERO":
      mes = 2;
      break;
    case "MARZO":
      mes = 3;
      break;
    case "ABRIL":
      mes = 4;
      break;
    case "MAYO":
      mes = 5;
      break;
    case "JUNIO":
      mes = 6;
      break;
    case "JULIO":
      mes = 7;
      break;
    case "AGOSTO":
      mes = 8;
      break;
    case "SEPTIEMBRE":
      mes = 9;
      break;
    case "OCTUBRE":
      mes = 10;
      break;
    case "NOVIEMBRE":
      mes = 11;
      break;
    case "DICIEMBRE":
      mes = 12;
      break;
    default:
      mes = "0";
      break;
  }
  return mes;
};

export const formatMoneda = (num, decSep, thousandSep, decLength) => {
  let sign = "";
  if (
    typeof parseFloat(num.replace(",", ".")) === "number" &&
    parseFloat(num.replace(",", ".")) < 0
  ) {
    sign = "-";
    // num = Math.abs(num);
  }
  if (num === "") return "";
  var arg, entero, decLengthpow;
  // sign = true;

  cents = "";
  if (typeof num === "undefined") return;
  if (typeof decLength === "undefined") decLength = 2;
  if (typeof decSep === "undefined") decSep = ",";
  if (typeof thousandSep === "undefined") thousandSep = ".";
  if (thousandSep === ".") arg = /\./g;
  else if (thousandSep === ",") arg = /\,/g;
  if (typeof arg != "undefined") num = num.toString().replace(arg, "");
  num = num.toString().replace(/,/g, ".");
  if (num.indexOf(".") != 1) entero = num.substring(0, num.indexOf("."));
  else entero = num;
  if (isNaN(num)) return "0";
  if (decLength > 0) {
    decLengthpow = Math.pow(10, decLength);
    /// sign = num === (num = Math.abs(num));
    num = Math.abs(num);
    num = Math.round(num * decLengthpow);
    var cents = num % decLengthpow;
    num = Math.floor(num / decLengthpow).toString();
    if (cents < 10) cents = "0" + cents;
  }
  if (thousandSep != "")
    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
      num =
        num.substring(0, num.length - (4 * i + 3)) +
        thousandSep +
        num.substring(num.length - (4 * i + 3));
  else
    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
      num =
        num.substring(0, num.length - (4 * i + 3)) +
        num.substring(num.length - (4 * i + 3));
  if (decLength > 0) return (sign ? sign : " ") + num + decSep + cents;
  else return (sign ? sign : " ") + num;
};

export function formatearMonto(monto, decimales = 2, local = "de-DE") {
  // Redondear el monto a tres decimales
  var montoFormateado = parseFloat(monto).toFixed(decimales);

  // Formatear el monto según la configuración regional actual del usuario
  return parseFloat(montoFormateado).toLocaleString(local);
}

/* export const formatMoneda = (num, decSep, thousandSep, decLength) => {
  if (num === "") return "";
  var arg,
    entero,
    decLengthpow,
    sign = true;
  cents = "";
  if (typeof num === "undefined") return;
  if (typeof decLength === "undefined") decLength = 2;
  if (typeof decSep === "undefined") decSep = ",";
  if (typeof thousandSep === "undefined") thousandSep = ".";
  if (thousandSep === ".") arg = /\./g;
  else if (thousandSep === ",") arg = /\,/g;
  if (typeof arg != "undefined") num = num.toString().replace(arg, "");
  num = num.toString().replace(/,/g, ".");
  if (num.indexOf(".") != 1) entero = num.substring(0, num.indexOf("."));
  else entero = num;
  if (isNaN(num)) return "0";
  if (decLength > 0) {
    decLengthpow = Math.pow(10, decLength);
    sign = num === (num = Math.abs(num));
    num = Math.round(num * decLengthpow);
    var cents = num % decLengthpow;
    num = Math.floor(num / decLengthpow).toString();
    if (cents < 10) cents = "0" + cents;
  }
  if (thousandSep != "")
    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
      num =
        num.substring(0, num.length - (4 * i + 3)) +
        thousandSep +
        num.substring(num.length - (4 * i + 3));
  else
    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
      num =
        num.substring(0, num.length - (4 * i + 3)) +
        num.substring(num.length - (4 * i + 3));
  if (decLength > 0) return (sign ? "" : " ") + num + decSep + cents;
  else return (sign ? "" : " ") + num;
}; */

export const seleccionarCampo = (event) => {
  $(event.target).select();
};

export const validaMonto = (event) => {
  $(event.target).val(function (index, value) {
    let sign = "";
    if (value.indexOf("-") === 0) {
      sign = "-";
    }
    return (
      sign +
      value
        .replace(/\D/g, "")
        .replace(/([0-9])([0-9]{2})$/, "$1,$2")
        .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ".")
    );
  });
};

export const validaMonto3 = (event) => {
  $(event.target).val(function (index, value) {
    return value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{3})$/, "$1,$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ".");
  });
};

export const validaSoloNumero = (event) => {
  $(event.target).val(function (index, value) {
    return value.replace(/\D/g, "");
  });
};

export const validarnumberguion = (event) => {
  $(event.target).val(function (index, value) {
    return value.replace(/[^A-Z\d-]/g, "");
  });
};

export const validaNumeroTelefono = (inputtxt) => {
  //var tlfno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  var tlfno = /^\(?([0-9]{4})\)?[-. ]?([0-9]{7})$/;
  if (inputtxt.match(tlfno)) {
    return true;
  } else {
    return false;
  }
};

export const validaEmail = (inputtxt) => {
  //var tlfno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  var email = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
  if (inputtxt.match(email)) {
    return true;
  } else {
    return false;
  }
};

export function lpad(str, padStr, length) {
  return (padStr + str).slice(-length);
}

export const habilitarcampos = (frm) => {
  $("#" + frm + " input").removeAttr("readonly");
  $("#" + frm + " input").removeAttr("disabled");
  $("#" + frm + ' input[type="radio"]').removeAttr("disabled");
  $("#" + frm + ' input[type="checkbox"]').removeAttr("disabled");
  $("#" + frm + " textarea").removeAttr("readonly");
  $("#" + frm + " textarea").removeAttr("disabled");
  $("#" + frm + " select").removeAttr("disabled");
  $("#" + frm + " .input-fecha").mask("99/99/9999");
  $("#" + frm + " .input-fecha").attr("placeholder", "dd/mm/aaaa");
  $("#" + frm + " .txtRif").mask("R-99999999-9");
  $("#" + frm + " .txtRif").attr("placeholder", "J-99999999-9");
};

export const habilitarcampo = (campo) => {
  $("#" + campo).removeAttr("readonly");
  $("#" + campo).removeAttr("disabled");
};

export function formatoMonto(val) {
  var valor = "";
  let n = 3;
  if (val.indexOf("-") === 0) {
    n = 4;
  }
  if (val.length < n && val !== "") valor = val + ",00";
  else valor = val;
  return valor;
}

export function formatoMonto3(val) {
  var valor = "";
  if (val.length < 4 && val !== "") valor = val + ",000";
  else valor = val;
  return valor;
}

export function timeout(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function formatFecha(fecha, format, sig) {
  let anio = fecha.substring(0, 4);
  let mes = fecha.substring(5, 7);
  let dia = fecha.substring(8, 10);

  if (format === "YYYY-MM-DD") {
    return anio + sig + mes + sig + dia;
  } else if (format === "DD-MM-YYYY") {
    return dia + sig + mes + sig + anio;
  } else if (format === "YYYY") {
    return anio;
  } else {
    return anio + sig + mes + sig + dia;
  }
}

var code;

export const Captcha = () => {
  var alpha = new Array(
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z"
  );
  var alpha2 = new Array("1", "2", "3", "4", "5", "6", "7", "8", "9", "0");
  var i;
  for (i = 0; i < 6; i++) {
    var a = alpha[Math.floor(Math.random() * alpha.length)];
    var b = alpha2[Math.floor(Math.random() * alpha2.length)];
    var c = alpha[Math.floor(Math.random() * alpha.length)];
    var d = alpha2[Math.floor(Math.random() * alpha2.length)];
    var e = alpha[Math.floor(Math.random() * alpha.length)];
    var f = alpha2[Math.floor(Math.random() * alpha2.length)];
    var g = alpha[Math.floor(Math.random() * alpha.length)];
  }
  var texto =
    a + " " + b + " " + " " + c + " " + d + " " + e + " " + f + " " + g;
  //CreaIMG(code);

  var ctxCanvas = document.getElementById("captcha").getContext("2d");
  var fontSize = "30px";
  var fontFamily = "Arial";
  var width = 250;
  var height = 50;
  //tamaño
  ctxCanvas.canvas.width = width;
  ctxCanvas.canvas.height = height;
  //color de fondo
  ctxCanvas.fillStyle = "whitesmoke";
  ctxCanvas.fillRect(0, 0, width, height);
  //puntos de distorsion
  ctxCanvas.setLineDash([7, 10]);
  ctxCanvas.lineDashOffset = 5;
  ctxCanvas.beginPath();
  var line;
  for (var i = 0; i < width; i++) {
    line = i * 5;
    ctxCanvas.moveTo(line, 0);
    ctxCanvas.lineTo(0, line);
  }
  ctxCanvas.stroke();
  //formato texto
  ctxCanvas.direction = "ltr";
  ctxCanvas.font = fontSize + " " + fontFamily;
  //texto posicion
  var x = width / 9;
  var y = (height / 3) * 2;
  //color del borde del texto
  ctxCanvas.strokeStyle = "yellow";
  ctxCanvas.strokeText(texto, x, y);
  //color del texto
  ctxCanvas.fillStyle = "red";
  ctxCanvas.fillText(texto, x, y);
  //document.getElementById('mainCaptcha').value=texto;
  code = texto;
  document.getElementById("txtInput").value = ""; //linea cambiada llamando a la función para crear la imagen en un canvas
};

export const ValidCaptcha = () => {
  var string1 = removeSpaces(code);

  var string2 = removeSpaces(document.getElementById("txtInput").value);

  if (string1 === string2) {
    document.getElementById("txtInput").value = "";
    return true;
  } else {
    Captcha();
    document.getElementById("txtInput").value = "";
    return false;
  }
};
export const removeSpaces = (string) => {
  return string.split(" ").join("");
};

export const mascara = (d, sep, pat, nums) => {
  //if (d.valant != d.value) {
  var val = d.target.value;
  var largo = val.length;
  var val = val.split(sep);
  var val2 = "";
  for (let r = 0; r < val.length; r++) {
    val2 += val[r];
  }

  if (nums) {
    var letra = "";
    for (let z = 0; z < val2.length; z++) {
      if (isNaN(val2.charAt(z))) {
        letra = new RegExp(val2.charAt(z), "g");
        val2 = val2.replace(letra, "");
      }
    }
  }

  var val = "";
  var val3 = new Array();

  for (let s = 0; s < pat.length; s++) {
    val3[s] = val2.substring(0, pat[s]);
    val2 = val2.substr(pat[s]);
  }

  for (let q = 0; q < val3.length; q++) {
    if (q === 0) {
      val = val3[q];
    } else {
      if (val3[q] != "") {
        val += sep + val3[q];
      }
    }
  }
  $(event.target).val(val);
  //d.value = val;
  //d.valant = val;
  //}
};

export const validarRif = (d) => {
  //if (d.valant != d.value) {
  var pat = new Array(1, 8, 1);
  var val = d.target.value;
  var largo = val.length;
  var sep = "-";
  var val = val.split(sep);
  var val2 = "";
  for (let r = 0; r < val.length; r++) {
    val2 += val[r];
  }

  var val = "";
  var val3 = new Array();

  for (let s = 0; s < pat.length; s++) {
    val3[s] = val2.substring(0, pat[s]);
    val2 = val2.substr(pat[s]);
  }

  for (let q = 0; q < val3.length; q++) {
    if (q === 0) {
      val = val3[q];
    } else {
      if (val3[q] != "") {
        val += sep + val3[q];
      }
    }
  }
  if (
    val.toUpperCase().substring(0, 1) !== "J" &&
    val.toUpperCase().substring(0, 1) !== "P" &&
    val.toUpperCase().substring(0, 1) !== "V" &&
    val.toUpperCase().substring(0, 1) !== "E" &&
    val.toUpperCase().substring(0, 1) !== "G"
  ) {
    val = "";
  }
  if (val.length > 2) {
    var letra = "";
    var size = 0;
    if (val.length > 10) {
      size = 10;
    } else {
      size = val.length;
    }
    for (let z = 2; z < size; z++) {
      if (isNaN(val.charAt(z))) {
        letra = new RegExp(val.charAt(z), "g");
        if (z === 2) {
          val = val.replace(letra, "").replace("-", "");
        } else {
          val = val.replace(letra, "");
        }
      }
    }
  }
  if (val.length > 10) {
    for (let y = 11; y < val.length; y++) {
      if (isNaN(val.charAt(y))) {
        letra = new RegExp("-" + val.charAt(y), "g");
        val = val.replace(letra, "");
      }
    }
  }
  $(event.target).val(val.toUpperCase());
  //d.value = val;
  //d.valant = val;
  //}
};

export const validaNumRif = (inputtxt) => {
  var rif = /^([VEJPGvejpg]{1})-([0-9]{8})-([0-9]{1}$)/;
  if (inputtxt.match(rif)) {
    return true;
  } else {
    return false;
  }
};

export const validaNumRifSinGuion = (inputtxt) => {
  var rif = /^([VEJPGvejpg]{1})([0-9]{8})([0-9]{1}$)/;
  if (inputtxt.match(rif)) {
    return true;
  } else {
    return false;
  }
};

export const validarArchivoRetencion = (event) => {
  var archivo = event.target.files[0];
  if (!archivo) {
    return;
  }
  var lector = new FileReader();

  lector.readAsText(archivo);
  //lector.onload = cargarArchivo(event);
  var resp = (lector.onload = function (e) {
    var contenido = e.target.result;
    var lineas = contenido.split("\n");

    respuesta = validarCamposArchivo(lineas);
    return respuesta;
    /*var cont = 0;
    for (var linea of lineas) {
      cont++;
      alert('linea: ' + cont + ' ' + linea)
    }*/
  });
  //lector.readAsText(archivo);
  respuesta = resp;
  return respuesta;
};

export const validarCamposArchivo = (datos) => {
  var fila = [];
  var resp = [];
  var msj = "";
  var pat = "";
  var mat = true;
  var valido = true;
  var filaLlena = -1;
  var filaVacia = -1;
  for (let i = 0; i < datos.length; i++) {
    if (datos[i].toString().trim().length > 0) {
      filaLlena = i;
      if ((filaLlena > filaVacia) & (filaVacia >= 0)) {
        //console.error("LA LINEA " + i + " ESTA VACIA");
        //console.error("ARCHIVO INVALIDO");

        valido = false;
        msj = "LA LINEA " + i + " ESTA VACIA ARCHIVO INVALIDO";
        resp.push(false);
        resp.push(msj);
        //respuesta.put("msj","LA LINEA " + i + " ESTA VACIA ARCHIVO INVALIDO");
        //return false;
        return resp;
      }
      //fila = datos[i].toString().split("\t");
      fila = datos[i].toString().split("|");
      for (let j = 0; j < fila.length; j++) {
        switch (j) {
          case 0:
            /* if (fila[j].trim().replace("\uFEFF", "").length > 5 || !fila[j].trim().replace("\uFEFF", "").match("\\d{4,5}")) {
              //console.error("CODIGO O NUMERO DE AGENTE DE RETENCION " + fila[j] + " INVALIDO LINEA " + (i + 1));
              //console.error("ARCHIVO INVALIDO");

              valido = false;
              msj = "CODIGO O NUMERO DE AGENTE DE RETENCION " + fila[j] + " INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
              resp.push(false);
              resp.push(msj);
              return resp;
            } */
            if (
              fila[j].trim().replace("\uFEFF", "").length > 4 ||
              !fila[j].trim().replace("\uFEFF", "").match("\\d{4}")
            ) {
              //console.error("NUMERO DE OPERACION " + fila[j] + " INVALIDO LINEA " + (i + 1));

              valido = false;
              msj =
                "NUMERO DE OPERACION " +
                fila[j] +
                " INVALIDO LINEA " +
                (i + 1) +
                " ARCHIVO INVALIDO";
              resp.push(false);
              resp.push(msj);
              return resp;
            }

            break;

          case 1:
            if (fila[j].trim() === "") {
              //console.error("TIPO DE INSTRUMENTO '" + fila[j].trim() + "' INVALIDO LINEA " + (i + 1));
              //console.error("ARCHIVO INVALIDO");
              //msj= "NOMBRE DEL SUJETO RETENIDO '" + fila[j].trim() + "' INVALIDO LINEA " + (i+1) + "ARCHIVO INVALIDO";
              valido = false;
              msj =
                "TIPO DE INSTRUMENTO '" +
                fila[j].trim() +
                "' INVALIDO LINEA " +
                (i + 1) +
                " ARCHIVO INVALIDO";
              resp.push(false);
              resp.push(msj);
              return resp;
            }

            break;

          case 2:
            pat = "(\\d{6,12})$";

            // Asociar el string al patron
            //mat = pat.matcher(fila[j].trim());
            if (fila[j].trim().length < 6 || !fila[j].trim().match(pat)) {
              //console.error("NUMERO DE INSTRUMENTO " + fila[j] + " INVALIDO LINEA " + (i + 1));
              //console.error("ARCHIVO INVALIDO");
              //msj="NUMERO DE COMPROBANTE DE RETENCION " + fila[j] + " INVALIDO LINEA " + (i+1) + "ARCHIVO INVALIDO";
              valido = false;
              msj =
                "NUMERO DE INSTRUMENTO " +
                fila[j] +
                " INVALIDO LINEA " +
                (i + 1) +
                " ARCHIVO INVALIDO";
              resp.push(false);
              resp.push(msj);
              return resp;
            }

            break;

          case 3:
            pat = "^([0][1-9]|[12][0-9]|3[01])-([0][1-9]|[1][0-2])-(\\d{4})$";

            // Asociar el string al patron
            //mat = pat.matcher(fila[j].trim());
            if (!fila[j].trim().match(pat)) {
              //console.error("FECHA DE EMISION " + fila[j] + " INVALIDA LINEA " + (i + 1));
              //console.error("ARCHIVO INVALIDO");
              //msj= "FECHA DE FACTURA " + fila[j] + " INVALIDA LINEA " + (i+1) + "ARCHIVO INVALIDO";
              valido = false;
              msj =
                "FECHA DE EMISION " +
                fila[j] +
                " INVALIDA LINEA " +
                (i + 1) +
                " ARCHIVO INVALIDO";
              resp.push(false);
              resp.push(msj);
              return resp;
            }

            break;

          case 4:
            if (fila[j].trim() === "") {
              //console.error("NOMBRE O RAZON SOCIAL '" + fila[j].trim() + "' INVALIDO LINEA " + (i + 1));
              //console.error("ARCHIVO INVALIDO");
              //msj= "NOMBRE DEL SUJETO RETENIDO '" + fila[j].trim() + "' INVALIDO LINEA " + (i+1) + "ARCHIVO INVALIDO";
              valido = false;
              msj =
                "NOMBRE O RAZON SOCIAL '" +
                fila[j].trim() +
                "' INVALIDO LINEA " +
                (i + 1) +
                " ARCHIVO INVALIDO";
              resp.push(false);
              resp.push(msj);
              return resp;
            }

            break;

          case 5:
            //pat = "^[JVGE]-\\d{8}-\\d{1}$";
            pat = "^[JVGE]\\d{8}\\d{1}$";

            // Asociar el string al patron

            //mat = pat.matcher(fila[j].trim());
            if (!fila[j].trim().match(pat)) {
              //console.error("CEDULA O RIF " + fila[j] + " INVALIDO LINEA " + (i + 1));
              //console.error("ARCHIVO INVALIDO");
              //msj="RIF AGENTE DE RETENCION " + fila[j] + " INVALIDO LINEA " + (i+1)+ "ARCHIVO INVALIDO";
              valido = false;
              msj =
                "CEDULA O RIF " +
                fila[j] +
                " INVALIDO LINEA " +
                (i + 1) +
                " ARCHIVO INVALIDO";
              resp.push(false);
              resp.push(msj);
              return resp;
            }

            break;

          case 6:
            //pat = "^-?\\d*\\,{0,1}\\d+$";
            pat = "^-?\\d*\\.{0,1}\\d+$";

            // Asociar el string al patron
            //mat = pat.matcher(fila[j].trim());
            if (!fila[j].trim().match(pat)) {
              //console.error("MONTO BRUTO " + fila[j] + " INVALIDO LINEA " + (i + 1));
              //console.error("ARCHIVO INVALIDO");
              valido = false;
              msj =
                "MONTO BRUTO " +
                fila[j] +
                " INVALIDO LINEA " +
                (i + 1) +
                " ARCHIVO INVALIDO";
              resp.push(false);
              resp.push(msj);
              return resp;
            }

            break;

          case 7:
            //pat = "^-?\\d*\\,{0,1}\\d+$";
            pat = "^-?\\d*\\.{0,1}\\d+$";

            // Asociar el string al patron
            //mat = pat.matcher(fila[j].trim());
            if (!fila[j].trim().match(pat)) {
              //console.error("IMPUESTO 1X500 " + fila[j] + " INVALIDO LINEA " + (i + 1));
              //console.error("ARCHIVO INVALIDO");
              valido = false;
              msj =
                "IMPUESTO 1X500 " +
                fila[j] +
                " INVALIDO LINEA " +
                (i + 1) +
                " ARCHIVO INVALIDO";
              resp.push(false);
              resp.push(msj);
              return resp;
            }

            break;

          /*case 14:

            pat = "\\d{1,3},\\d{1,2}%$";

            // Asociar el string al patron
            //mat = pat.matcher(fila[j].trim());
            if (!fila[j].trim().match(pat)) {
              //console.error("% DE ALICUOTA " + fila[j] + " INVALIDO LINEA " + (i + 1));
              //console.error("ARCHIVO INVALIDO");
              //msj="% DE ALICUOTA " + fila[j] + " INVALIDO LINEA " + (i+1) + "ARCHIVO INVALIDO";
              valido = false;
              msj = "% DE ALICUOTA " + fila[j] + " INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
              resp.push(false);
              resp.push(msj);
              return resp;
            }

            break;

          case 2:

            pat = "^[DT]$";

            // Asociar el string al patron
            //mat = pat.matcher(fila[j].trim());
            if (!fila[j].trim().match(pat)) {
              //console.error("TIPO CONTRIBUYENTE '" + fila[j].trim() + "' INVALIDO LINEA " + (i + 1));
              //console.error("ARCHIVO INVALIDO");
              valido = false;
              msj = "TIPO CONTRIBUYENTE '" + fila[j].trim() + "' INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
              resp.push(false);
              resp.push(msj);
              return resp;
            }

            break;

          case 3:
            pat = "^\\d{4}$";

            // Asociar el string al patron
            //mat = pat.matcher(fila[j].trim());
            if (!fila[j].trim().match(pat)) {
              //console.error("AÑO DEL PERIODO IMPOSITIVO " + fila[j] + " INVALIDO LINEA " + (i + 1));
              //console.error("ARCHIVO INVALIDO");
              //msj= "AÑO DEL PERIODO IMPOSITIVO " + fila[j] + " INVALIDO LINEA " + (i+1) + "ARCHIVO INVALIDO";
              valido = false;
              msj = "AÑO DEL PERIODO IMPOSITIVO " + fila[j] + " INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
              resp.push(false);
              resp.push(msj);
              return resp;
            }

            break;

          case 4:

            pat = "[0][1-9]|[1][0-2]$";

            // Asociar el string al patron
            //mat = pat.matcher(fila[j].trim());
            if (!fila[j].trim().match(pat)) {
              //console.error("MES DEL PERIODO IMPOSITIVO " + fila[j].trim() + " INVALIDO LINEA " + (i + 1));
              //console.error("ARCHIVO INVALIDO");
              //msj= "MES DEL PERIODO IMPOSITIVO " + fila[j].trim() + " INVALIDO LINEA " + (i+1) + "ARCHIVO INVALIDO";
              valido = false;
              msj = "MES DEL PERIODO IMPOSITIVO " + fila[j].trim() + " INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
              resp.push(false);
              resp.push(msj);
              return resp;
            }

            break;

          case 5:
            if (fila[j].trim().length > 5 || !fila[j].match("\\d{4,5}[' ']*")) {
              //console.error("CODIGO O NUMERO DE AGENTE RETENIDO " + fila[j] + " INVALIDO LINEA " + (i + 1));
              //console.error("ARCHIVO INVALIDO");
              //msj= "CODIGO O NUMERO DE AGENTE RETENIDO " + fila[j] + " INVALIDO LINEA " + (i+1) + "ARCHIVO INVALIDO";
              valido = false;
              msj = "CODIGO O NUMERO DE AGENTE RETENIDO " + fila[j] + " INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
              resp.push(false);
              resp.push(msj);
              return resp;
            }

            break;

          case 6:

            pat = "^[JVGE]-\\d{8}-\\d{1}$";

            // Asociar el string al patron
            //mat = pat.matcher(fila[j].trim());
            if (!fila[j].trim().match(pat)) {
              //console.error("RIF DEL SUJETO RETENIDO " + fila[j] + " INVALIDO LINEA " + (i + 1));
              //console.error("ARCHIVO INVALIDO");
              //msj="RIF DEL SUJETO RETENIDO " + fila[j] + " INVALIDO LINEA " + (i+1) + "ARCHIVO INVALIDO";
              valido = false;
              msj = "RIF DEL SUJETO RETENIDO " + fila[j] + " INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
              resp.push(false);
              resp.push(msj);
              return resp;
            }

            break;

          case 8:

            pat = "^([0][1-9]|[12][0-9]|3[01])/([0][1-9]|[1][0-2])/(\\d{4})$";

            // Asociar el string al patron
            //mat = pat.matcher(fila[j].trim());
            if (!fila[j].trim().match(pat)) {
              //console.error("FECHA DE FACTURA " + fila[j] + " INVALIDA LINEA " + (i + 1));
              //console.error("ARCHIVO INVALIDO");
              //msj= "FECHA DE FACTURA " + fila[j] + " INVALIDA LINEA " + (i+1) + "ARCHIVO INVALIDO";
              valido = false;
              msj = "FECHA DE FACTURA " + fila[j] + " INVALIDA LINEA " + (i + 1) + " ARCHIVO INVALIDO";
              resp.push(false);
              resp.push(msj);
              return resp;
            }

            break;

          case 11:

            pat = "(\\d{4})([0][1-9]|[1][0-2])(\\d{1,14})$";

            // Asociar el string al patron
            //mat = pat.matcher(fila[j].trim());
            if (fila[j].trim().length < 7 || !fila[j].trim().match(pat)) {
              //console.error("NUMERO DE COMPROBANTE DE RETENCION " + fila[j] + " INVALIDO LINEA " + (i + 1));
              //console.error("ARCHIVO INVALIDO");
              //msj="NUMERO DE COMPROBANTE DE RETENCION " + fila[j] + " INVALIDO LINEA " + (i+1) + "ARCHIVO INVALIDO";
              valido = false;
              msj = "NUMERO DE COMPROBANTE DE RETENCION " + fila[j] + " INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
              resp.push(false);
              resp.push(msj);
              return resp;
            }

            break;

          case 12:

            pat = "^([0][1-9]|[12][0-9]|3[01])/([0][1-9]|[1][0-2])/(\\d{4})$";

            // Asociar el string al patron
            //mat = pat.matcher(fila[j].trim());
            if (!fila[j].trim().match(pat)) {
              //console.error("FECHA DE RETENCIÓN " + fila[j] + " INVALIDA LINEA " + (i + 1));
              //console.error("ARCHIVO INVALIDO");
              //msj="FECHA DE RETENCIÓN " + fila[j] + " INVALIDA LINEA " + (i+1) + "ARCHIVO INVALIDO";
              valido = false;
              msj = "FECHA DE RETENCIÓN " + fila[j] + " INVALIDA LINEA " + (i + 1) + " ARCHIVO INVALIDO";
              resp.push(false);
              resp.push(msj);
              return resp;
            }

            break;*/

          /*case 16:

            filaVacia = i;
            if(filaLlena > filaVacia & filaVacia >= 0){
              ////console.error("FILA " + i + " ESTA VACIA");
              ////console.error("ARCHIVO INVALIDO");
              respuesta.clear();
                          respuesta.put("valido", false);
                          respuesta.put("msj", "FILA " + i + " ESTA VACIA ARCHIVO INVALIDO");
                        return false;
            	
            }
            	
            break;*/
          default:
            break;
        }
      }
    } else {
      filaVacia = i;
      if ((filaLlena > filaVacia) & (filaVacia >= 0)) {
        //console.error("FILA " + i + " ESTA VACIA");
        //console.error("ARCHIVO INVALIDO");
        //msj="FILA " + i + " ESTA VACIA ARCHIVO INVALIDO";
        valido = false;
        msj = "FILA " + i + " ESTA VACIA ARCHIVO INVALIDO";
        resp.push(false);
        resp.push(msj);
        return resp;
      }
    }
  }
  if (valido) {
    resp.push(true);
    resp.push("ARCHIVO VALIDO");
    return resp;
  }
};

export const cargarCamposArchivo = (datos, tipoage) => {
  var fila = [];
  var rete = [];
  var txtNumOpe = "";
  var txtNumIns = "";
  var txtTipoIns = "";
  var txtCedRif = "";
  var txtRazonSoc = "";
  var txtFecEmi = "";
  var txtMonBruto = "";
  var txtRete1x500 = "";

  moment.locale("es");
  for (let i = 0; i < datos.length; i++) {
    if (datos[i].toString().trim().length > 0) {
      fila = datos[i].toString().split("|");
      for (let j = 0; j < fila.length; j++) {
        switch (j) {
          case 0:
            txtNumOpe = fila[j].trim().replace("\uFEFF", "");
            break;
          case 1:
            txtTipoIns = fila[j].trim();
            break;

          case 2:
            txtNumIns = fila[j].trim();
            break;

          case 3:
            txtFecEmi = fila[j].trim();
            break;

          case 4:
            txtRazonSoc = fila[j].trim();
            break;

          case 5:
            txtCedRif = fila[j].trim();
            break;

          case 6:
            txtMonBruto = formatMoneda(
              fila[j].trim().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );
            break;

          case 7:
            txtRete1x500 = formatMoneda(
              fila[j].trim().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );
            break;

          /*case 8:
            //txtFecFactura = fila[j].trim();
            fecha = fila[j].trim().split("/");
            txtFecEmi = fecha[2].trim() + "-" + fecha[1].trim() + "-" + fecha[0].trim();

            break;

          case 9:
            txtNumFactura = fila[j].trim();

            break;

          case 10:
            txtRete1x500 = fila[j].trim();

            break;

          case 11:
            txtNumComprobante = fila[j].trim();

            break;

          case 12:
            //txtFecComprobante = fila[j].trim();
            fecha = fila[j].trim().split("/");
            txtFecComprobante = fecha[2].trim() + "-" + fecha[1].trim() + "-" + fecha[0].trim();

            break;

          case 13:
            txtMonBruto = fila[j].trim();

            break;

          case 14:
            txtAlicuota = fila[j].trim();

            break;

          case 15:
            txtMonRete = fila[j].trim();

            break;*/

          default:
            break;
        }
      }
      rete.push({
        numope: txtNumOpe,
        tipoins: txtTipoIns,
        numins: txtNumIns,
        cedrif: txtCedRif,
        nombre: txtRazonSoc,
        //fecemi: moment(txtFecEmi.toString()).format('YYYY-MM-DD'),
        fecemi: txtFecEmi,
        monbruto: txtMonBruto,
        monrete: txtRete1x500,
      });
    }
  }
  return rete;
};

export const generar = (longitud) => {
  var long = parseInt(longitud);
  var caracteres = "abcdefghijkmnpqrtuvwxyzABCDEFGHIJKLMNPQRTUVWXYZ2346789";
  var contraseña = "";
  for (var i = 0; i < long; i++)
    contraseña += caracteres.charAt(
      Math.floor(Math.random() * caracteres.length)
    );
  return contraseña;
};

export const colores = [
  "#17a2b8",
  "#ffae00",
  "#dc3545",
  "#BDB76B",
  "#7B68EE",
  "#4B0082",
  "#00ffff",
  "#0080ff",
  "#0000ff",
  "#8000ff",
  "#ff00ff",
  "#ff0080",
  "#0099FF",
  "#00CC66",
  "#6600CC",
  "#CCFF00",
  "#FF66FF",
  "#00CCCC",
  "#996600",
  "#CC00CC",
  "#3399FF",
  "#990000",
  "#FFFF99",
  "#FF9900",
];

export const colores2 = [
  "#0000FF",
  "#003300",
  "#006600",
  "#0066FF",
  "#0099FF",
  "#00CC66",
  "#00CCCC",
  "#00FF99",
  "#00FFCC",
  "#00FFFF",
  "#330099",
  "#333300",
  "#333366",
  "#3333FF",
  "#336600",
  "#336633",
  "#336666",
  "#336699",
  "#3366CC",
  "#3366FF",
  "#339900",
  "#339933",
  "#339966",
  "#339999",
  "#3399CC",
  "#3399FF",
  "#33CC00",
  "#33CC33",
  "#33CC66",
  "#33CC99",
  "#33CCCC",
  "#33CCFF",
  "#33FF00",
  "#33FF33",
  "#33FF66",
  "#33FF99",
  "#33FFCC",
  "#33FFFF",
  "#660000",
  "#660033",
  "#660066",
  "#660099",
  "#6600CC",
  "#6600FF",
  "#663300",
  "#663333",
  "#663366",
  "#663399",
  "#6633CC",
  "#6633FF",
  "#666600",
  "#666633",
  "#666666",
  "#666699",
  "#6666CC",
  "#6666FF",
  "#669900",
  "#669933",
  "#669966",
  "#669999",
  "#6699CC",
  "#6699FF",
  "#66CC00",
  "#66CC33",
  "#66CC66",
  "#66CC99",
  "#66CCCC",
  "#66CCFF",
  "#66FF00",
  "#66FF33",
  "#66FF66",
  "#66FF99",
  "#66FFCC",
  "#66FFFF",
  "#990000",
  "#990033",
  "#990066",
  "#990099",
  "#9900CC",
  "#9900FF",
  "#993300",
  "#993333",
  "#993366",
  "#993399",
  "#9933CC",
  "#9933FF",
  "#996600",
  "#996633",
  "#996666",
  "#996699",
  "#9966CC",
  "#9966FF",
  "#999900",
  "#999933",
  "#999966",
  "#999999",
  "#9999CC",
  "#9999FF",
  "#99CC00",
  "#99CC33",
  "#99CC66",
  "#99CC99",
  "#99CCCC",
  "#99CCFF",
  "#99FF00",
  "#99FF33",
  "#99FF66",
  "#99FF99",
  "#99FFCC",
  "#99FFFF",
  "#CC0000",
  "#CC0033",
  "#CC0066",
  "#CC0099",
  "#CC00CC",
  "#CC00FF",
  "#CC3300",
  "#CC3333",
  "#CC3366",
  "#CC3399",
  "#CC33CC",
  "#CC33FF",
  "#CC6600",
  "#CC6633",
  "#CC6666",
  "#CC6699",
  "#CC66CC",
  "#CC66FF",
  "#CC9900",
  "#CC9933",
  "#CC9966",
  "#CC9999",
  "#CC99CC",
  "#CC99FF",
  "#CCCC00",
  "#CCCC33",
  "#CCCC66",
  "#CCCC99",
  "#CCCCCC",
  "#CCCCFF",
  "#CCFF00",
  "#CCFF33",
  "#CCFF66",
  "#CCFF99",
  "#CCFFCC",
  "#CCFFFF",
  "#FF0000",
  "#FF0033",
  "#FF0066",
  "#FF0099",
  "#FF00CC",
  "#FF00FF",
  "#FF3300",
  "#FF3333",
  "#FF3366",
  "#FF3399",
  "#FF33CC",
  "#FF33FF",
  "#FF6600",
  "#FF6633",
  "#FF6666",
  "#FF6699",
  "#FF66CC",
  "#FF66FF",
  "#FF9900",
  "#FF9933",
  "#FF9966",
  "#FF9999",
  "#FF99CC",
  "#FF99FF",
  "#FFCC00",
  "#FFCC33",
  "#FFCC66",
  "#FFCC99",
  "#FFCCCC",
  "#FFCCFF",
  "#FFFF00",
  "#FFFF33",
  "#FFFF66",
  "#FFFF99",
  "#FFFFCC",
  "#FFFFFF",
];

export const isResponseOk = (response) => {
  if (!response.ok) throw new Error(response.status);
  return response.text();
};

export const cmbCedula = [
  { value: "V" },
  { value: "J" },
  { value: "G" },
  { value: "P" },
  { value: "E" },
];

export const detallePedido = (data, operacion, estatus, moneda) => {
  let prod = [];
  let uni = [];
  let precio = 0.0;
  let tasa = 0.0;

  for (let i = 0; i < data.length; i++) {
    if (
      parseInt(data[i].idunidadalterna) === 0 ||
      data[i].idunidadalterna === null
    ) {
      uni = [
        {
          idunidad: data[i].idunidadmedida,
          descripcion: data[i].descripcionuni,
          tipo: "medida",
        },
      ];
      precio = data[i].costocalculado * (1 + data[i].utipreciomaxi / 100);
      precio = Math.round(precio * 100) / 100;
    } else {
      if (parseInt(data[i].tipounidad) === parseInt(data[i].idunidadmedida)) {
        precio = data[i].costocalculado * (1 + data[i].utipreciomaxi / 100);
        precio = Math.round(precio * 100) / 100;
        uni = [
          {
            idunidad: data[i].idunidadmedida,
            descripcion: data[i].descripcionuni,
            tipo: "medida",
          },
          {
            idunidad: data[i].idunidadalterna,
            descripcion: data[i].descripcionunialt,
            tipo: "alterna",
          },
        ];
      } else {
        precio =
          data[i].costocalculadoalter * (1 + data[i].utipreciomaxialter / 100);
        precio = Math.round(precio * 100) / 100;
        uni = [
          {
            idunidad: data[i].idunidadalterna,
            descripcion: data[i].descripcionunialt,
            tipo: "alterna",
          },
          {
            idunidad: data[i].idunidadmedida,
            descripcion: data[i].descripcionuni,
            tipo: "medida",
          },
        ];
      }
    }
    if (data[i].idmoneda === moneda.idmoneda) {
      tasa = data[i].valormoneda;
    } else {
      tasa = moneda.valormoneda;
    }
    if (!moneda.subpredeterminada) {
      precio = precio * data[i].valormoneda;
      precio = precio / tasa;
      precio = Math.round(precio * 100) / 100;
    } else {
      precio = data[i].punitario;
    }

    precio = Math.round(precio * 100) / 100;
    if (operacion === 4 && estatus === 1) {
      if (moneda.subpredeterminada) {
        precio = data[i].punitario;
      } else {
        precio = data[i].punitariobs;
      }
    }

    let montoiva = (precio * data[i].iva) / 100;
    montoiva = Math.round(montoiva * 100) / 100;

    let cantie = data[i].cantidade;
    let cantiea = 0.0;
    if (data[i].tipounidad === 0) {
      if (data[i].tipofactor === "1") {
        cantie = parseFloat(data[i].cantidade / data[i].valorfactor);
        cantie = Math.trunc(cantie);

        cantiea = parseFloat(data[i].cantidad * data[i].valorfactor);
        cantiea = Math.trunc(cantiea);
      }
    } else {
      if (data[i].tipofactor === "0") {
        cantie = parseFloat(data[i].cantidade / data[i].valorfactor);
        cantie = Math.trunc(cantie);

        cantiea = parseFloat(data[i].cantidad * data[i].valorfactor);
        cantiea = Math.trunc(cantiea);
      }
    }

    prod.push({
      idproducto: data[i].idproducto,
      codigo: data[i].codigo,
      cantidad: data[i].cantidad,
      cantidadE: parseFloat(cantie) + parseFloat(data[i].cantidad),
      cantidadEA: parseFloat(data[i].cantidade) + parseFloat(cantiea),
      nombrecorto: data[i].nombrecorto,
      precio: precio,
      precious: data[i].punitario,
      preciobs: data[i].punitariobs,
      iva: data[i].iva,
      ivaventa: data[i].ivaventa,
      montoiva: data[i].cantidad * montoiva,
      descuento: data[i].descuento,
      total: data[i].cantidad * precio,
      unidad: uni,
      idunidadmedida: data[i].idunidadmedida,
      idunidadalterna: data[i].idunidadalterna,
      costocalculado: data[i].costocalculado,
      costocalculadoalter: data[i].costocalculadoalter,
      utipreciomaxi: data[i].utipreciomaxi,
      utipreciomaxialter: data[i].utipreciomaxialter,
      tipounidad: data[i].tipounidad,
      valormoneda: data[i].valormoneda,
      idmoneda: data[i].idmoneda,
      tipofactor: data[i].tipofactor,
      valorfactor: data[i].valorfactor,
    });
  }

  return prod;
};

export const validarCantidadPedido = (event) => {
  validaMonto(event);
  if (event.which === 13 || typeof event.which === "undefined") {
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(".", "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "1,00";
    }
    event.target.value = formatoMonto(event.target.value);
    let char1 = event.target.value.substring(0, 1);
    let char2 = event.target.value.substring(1, 2);
    if (char1 === "0" && char2 !== ",") {
      event.target.value = event.target.value.substring(
        1,
        event.target.value.length
      );
    }
    return event.target.value;
  } else if (event.which === 46) {
    return false;
  } else if (event.which >= 48 && event.which <= 57) {
    return true;
  } else if (event.which === 8 || event.which === 0 || event.which === 44) {
    return true;
  } else return false;
};

export const round = (num, decimales = 2) => {
  var signo = num >= 0 ? 1 : -1;
  num = num * signo;
  if (decimales === 0)
    //con 0 decimales
    return signo * Math.round(num);
  // round(x * 10 ^ decimales)
  num = num.toString().split("e");
  num = Math.round(
    +(num[0] + "e" + (num[1] ? +num[1] + decimales : decimales))
  );
  // x * 10 ^ (-decimales)
  num = num.toString().split("e");
  return signo * (num[0] + "e" + (num[1] ? +num[1] - decimales : -decimales));
};

export const fabricantes = {
  "CERVECERIA POLAR": "1",
  "ALIMENTOS POLAR": "2",
  "P&G": "3",
  POMAR: "4",
  PEPSI: "5",
};

export const unidadmedidas = {
  "POR DEFINIR": "0",
  "POR DEFINIR ALTER": "1",
  LITROS: "91",
  BULTO: "92",
  SACOS: "93",
  KILOS: "94",
  PACAS: "95",
  CAJAS: "96",
  TONELADAS: "98",
  PORRON: "99",
  GRAMOS: "100",
  UNIDAD: "101",
  CC: "102",
};

export const tipoproducto = {
  "POR DEFINIR": "0",
  BEBIDAS: "119",
  ALIMENTOS: "120",
  VINOS: "122",
  VACIOS: "123",
  "P&G": "124",
  "USO PERSONAL": "125",
};

export const marcas = {
  PEPSI: "2",
  KIKER: "4",
  PAN: "5",
  SINDON: "6",
  POLAR: "8",
  POINTER: "9",
  HP: "10",
  MAVESA: "13",
  NELLY: "14",
  CHEF: "15",
  PAMPERO: "16",
  "LA VIENESA": "17",
  RIKESA: "18",
  PAN: "19",
  PRIMOR: "20",
  CORINA: "21",
  QUAKER: "22",
  "DON PANCHO": "23",
  MAZEITE: "24",
  TODDY: "25",
  GOLDEN: "26",
  KONGA: "27",
  MARGARITA: "28",
  CALIFORNIA: "29",
  MIGURT: "30",
  "LAS LLAVES": "31",
  "MULTI CLEAN": "32",
  DOGOURMET: "33",
  "SUPER CAN": "34",
  MALTIN: "35",
  "PEPSI-COLA": "36",
  "YUKY-PAK": "37",
  YUKERY: "38",
  "TE LIPTON": "39",
  GATORADE: "40",
  MINALBA: "41",
  EVERVESS: "42",
  CAROREÑA: "43",
  POMAR: "44",
  "POR DEFINIR": "0",
  KOLA: "46",
  VACIOS: "47",
  ACE: "48",
  ARIEL: "49",
  DOWNY: "50",
  PAMPERS: "51",
  ALWAYS: "52",
  "OLD SPICE": "53",
  GILLETTE: "54",
  HS: "55",
  PTN: "56",
  VENUS: "57",
  POMAR: "58",
};

export const modelos = {
  "POR DEFINIR": "0",
  LCD: "2",
  "2 LITROS": "3",
  LATA: "4",
  "1 KILO": "5",
  LITRO: "6",
  "250 GRAMOS": "8",
  "500 GRAMOS": "9",
  "1000 GRAMOS": "10",
  "400 GRAMOS": "11",
  "5 KILOGRAMOS": "12",
  "175 GRAMOS": "13",
  "445G": "14",
  "910 GRAMOS": "15",
  "3,6 KILOGRAMO": "16",
  "500 ML": "17",
  "1 LITRO": "18",
  "4 LITROS": "19",
  "198 GRAMOS": "20",
  "397 GRAMOS": "21",
  "4,2 KILOGRAMOS": "22",
  "240 GRAMOS": "23",
  "200 GRAMOS": "24",
  "300 GRAMOS": "25",
  "220 GRAMOS": "26",
  "225 GRAMOS": "27",
  "450 GRAMOS": "28",
  "900 GRAMOS": "29",
  "100 GRAMOS": "30",
  "800 GRAMOS": "31",
  "18 LITROS": "32",
  "2 KILOS": "33",
  "24 GRAMOS": "34",
  "125 GRAMOS": "35",
  "96 GRAMOS": "36",
  "30 GRAMOS": "37",
  "140 GRAMOS": "38",
  "170 GRAMOS": "39",
  "750 GRAMOS": "40",
  "510 ML": "41",
  "160 GRAMOS": "42",
  "500 CC": "43",
  "130 GRAMOS": "44",
  "950CC": "45",
  "530CC": "46",
  "4 KILOS": "47",
  "10 KILOS": "48",
  "18 KILOS": "49",
  "222 ML": "51",
  "4 GRAMOS": "73",
  "250 ML": "52",
  "330 ML": "50",
  "50 ML": "53",
  "0.250 ML": "54",
  "350 ML": "55",
  "1.25 LTS": "56",
  "1.5 L": "57",
  "355 ML": "58",
  "600 ML": "59",
  "5 LTS": "60",
  "30 L": "61",
  "295 ML": "62",
  "300 ML": "63",
  "0,75 LT": "64",
  "1,75 LT": "65",
  "800 CC": "67",
  "1900 CC": "68",
  "1800 CC": "69",
  "850 GRAMOS": "70",
  "500 GRAMOS": "71",
  "500 GRAMOS": "72",
  "432 GRAMOS": "74",
  "491 GRAMOS": "75",
  "463 GRAMOS": "76",
  "52 GRAMOS": "77",
  "60 GRAMOS": "78",
  "375 CC": "79",
  "180 CC": "80",
  "300 CC": "81",
  "400 CC": "82",
  "170 CC": "83",
  "200 CC": "84",
  "15 CC": "85",
  "525 CC": "86",
};

export const calcularTotales = (datos) => {
  let subtot = 0.0,
    descu = 0.0,
    montoiva = 0.0,
    totiva = 0.0,
    totexe = 0.0,
    totsuje = 0.0,
    ivapor = 0.0,
    totalm = 0.0;

  for (let i = 0; i < datos.length; i++) {
    if (parseFloat(datos[i].iva) > 0.0) {
      ivapor = parseFloat(datos[i].iva);
      totsuje = totsuje + parseFloat(datos[i].total);
      // IVA por producto: se suma el monto de iva ya calculado en el producto
      // (montoiva). Si el producto no lo trae, se calcula con su propio
      // porcentaje de iva sobre el total del producto.
      if (
        typeof datos[i].montoiva !== "undefined" &&
        datos[i].montoiva !== null &&
        !isNaN(parseFloat(datos[i].montoiva))
      ) {
        totiva = totiva + parseFloat(datos[i].montoiva);
      } else {
        totiva =
          totiva + round((parseFloat(datos[i].total) * ivapor) / 100, 2);
      }
    } else {
      totexe = totexe + parseFloat(datos[i].total);
    }
    subtot = subtot + parseFloat(datos[i].total);
  }

  montoiva = round(totiva, 2);
  totalm = round(totsuje + totexe + montoiva, 2);

  return {
    subtotal: round(subtot, 2),
    descuento: descu,
    exento: round(totexe, 2),
    sujeto: round(totsuje, 2),
    iva: ivapor,
    totaliva: montoiva,
    total: totalm,
  };
};

export const calcularTotalesDos = (datos) => {
  let subtot = 0.0,
    descu = 0.0,
    totiva = 0.0,
    totexe = 0.0,
    totsuje = 0.0,
    iva = 0.0,
    totalm = 0.0;

  for (let i = 0; i < datos.length; i++) {
    if (parseFloat(datos[i].iva) > 0.0) {
      iva = parseFloat(datos[i].iva);
      totsuje = totsuje + parseFloat(datos[i].totalsiniva);
      totiva = totiva + parseFloat(datos[i].totalivas);
    } else {
      totexe = totexe + parseFloat(datos[i].totalsiniva);
    }
    subtot = totsuje + totexe;
  }

  totalm = round(totsuje + totexe + totiva, 2);

  return {
    subtotal: round(subtot, 2),
    descuento: descu,
    exento: round(totexe, 2),
    sujeto: round(totsuje, 2),
    iva: iva,
    totaliva: round(totiva, 2),
    total: totalm,
  };
};

export const calcularTotales_Dos = (datos) => {
  let mtotal = 0.0,
    descu = 0.0,
    totiva = 0.0,
    totexe = 0.0,
    totsuje = 0.0,
    iva = 0.0,
    totalm = 0.0;

  for (let i = 0; i < datos.length; i++) {
    let base = 0.0;
    if (
      typeof datos[i].totalsiniva !== "undefined" &&
      datos[i].totalsiniva !== null &&
      !isNaN(parseFloat(datos[i].totalsiniva))
    ) {
      base = parseFloat(datos[i].totalsiniva);
    } else {
      base = parseFloat(datos[i].total);
    }
    if (isNaN(base)) base = 0.0;

    if (parseFloat(datos[i].iva) > 0.0) {
      iva = parseFloat(datos[i].iva);
      totsuje = totsuje + base;
      // IVA por producto: se suma el monto de iva ya calculado en la linea
      let ivaLinea = 0.0;
      if (
        typeof datos[i].totalivas !== "undefined" &&
        datos[i].totalivas !== null &&
        !isNaN(parseFloat(datos[i].totalivas))
      ) {
        ivaLinea = parseFloat(datos[i].totalivas);
      } else {
        ivaLinea = round((base * iva) / 100, 2);
      }
      totiva = totiva + ivaLinea;
    } else {
      totexe = totexe + base;
    }
    mtotal = totsuje + totexe;
  }

  totalm = round(totsuje + totexe + totiva, 2);

  return {
    subtotal: round(mtotal, 2),
    descuento: descu,
    exento: round(totexe, 2),
    sujeto: round(totsuje, 2),
    iva: iva,
    totaliva: round(totiva, 2),
    total: totalm,
  };
};

export const calculadora = (num1, num2, operador) => {
  let resultado = 0.0;
  if (operador === "+") {
    resultado = num1 + num2;
  }
  if (operador === "-") {
    resultado = num1 - num2;
  }
  if (operador === "*") {
    resultado = num1 * num2;
  }
  if (operador === "/") {
    resultado = num1 / num2;
  }

  return resultado;
};

export const regla3 = (num1, num2) => {
  let resultado = (num1 * num2) / 100 + num1;

  return resultado;
};

export const onCambioMoneda = ({ moneda, productos, monedaPre, monedaSub }) => {
  let data = [...productos];
  let valormoneda = 1.0;
  let monedacambio;

  if (moneda.idmoneda === monedaSub.idmoneda) {
    monedacambio = {
      idmoneda: moneda.idmoneda,
      descripcion: moneda.descripcion,
      simbolo: moneda.simbolo,
      predeterminada: moneda.predeterminada,
      subpredeterminada: moneda.subpredeterminada,
      valormoneda: 1.0,
    };
  } else if (moneda.idmoneda === monedaPre.idmoneda) {
    valormoneda = monedaSub.valormoneda;
    monedacambio = {
      idmoneda: moneda.idmoneda,
      descripcion: moneda.descripcion,
      simbolo: moneda.simbolo,
      predeterminada: moneda.predeterminada,
      subpredeterminada: moneda.subpredeterminada,
      valormoneda: monedaSub.valormoneda,
    };
  } else {
    valormoneda = round(monedaSub.valormoneda / moneda.valormoneda);
    monedacambio = {
      idmoneda: moneda.idmoneda,
      descripcion: moneda.descripcion,
      simbolo: moneda.simbolo,
      predeterminada: moneda.predeterminada,
      subpredeterminada: moneda.subpredeterminada,
      valormoneda: valormoneda,
    };
  }

  for (let i = 0; i < productos.length; i++) {
    data[i].valormoneda = valormoneda;
  }

  return {
    data,
    monedacambio,
  };
};

export const onCambioUnidad = ({ idunidad, index, productos }) => {
  let data = [...productos];
  let precio = 0.0;
  let montoiva = 0.0;
  let tipounidad = 0;
  let cantie = data[index].cantidadEA;
  let totales;
  let msm = {
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  };

  if (parseInt(idunidad) === parseInt(data[index].idunidadalterna)) {
    tipounidad = 1;
    cantie = parseFloat(data[index].cantidadEA);
    cantie = Math.trunc(cantie);

    if (parseInt(data[index].tipoprecio) === 1) {
      precio = parseFloat(data[index].preciomaxialter);
    } else if (parseInt(data[index].tipoprecio) === 2) {
      precio = parseFloat(data[index].precioofealter);
    } else if (parseInt(data[index].tipoprecio) === 3) {
      precio = parseFloat(data[index].preciomayoralter);
    } else if (parseInt(data[index].tipoprecio) === 4) {
      precio = parseFloat(data[index].preciominialter);
    }
  } else if (parseInt(idunidad) === parseInt(data[index].idunidadmedida)) {
    tipounidad = 0;
    cantie = parseFloat(data[index].cantidadEA / data[index].valorfactor);
    cantie = Math.trunc(cantie);

    if (parseInt(data[index].tipoprecio) === 1) {
      precio = parseFloat(data[index].preciomaxi);
    } else if (parseInt(data[index].tipoprecio) === 2) {
      precio = parseFloat(data[index].precioofe);
    } else if (parseInt(data[index].tipoprecio) === 3) {
      precio = parseFloat(data[index].preciomayor);
    } else if (parseInt(data[index].tipoprecio) === 4) {
      precio = parseFloat(data[index].preciomini);
    }
  }

  montoiva = (precio * parseFloat(data[index].iva)) / 100;

  if (parseFloat(data[index].cantidad) > cantie) {
    data[index].cantidad = 1.0;
    msm = {
      mostrar: true,
      titulo: "Notificación",
      texto: "La  cantidad no debe ser mayor a la cantidad existente",
      icono: "informacion",
    };
  }

  data[index].tipounidad = tipounidad;
  data[index].precio = precio;
  data[index].precioconiva = round((precio + montoiva), 2);
  data[index].unidad = data[index].unidad.reverse();
  data[index].total = precio * data[index].cantidad;
  data[index].montoiva = round(montoiva * data[index].cantidad, 2);
  data[index].cantidadE = cantie;

  totales = calcularTotales(data);

  return {
    data,
    msm,
    totales,
  };
};

export const onCambioUnidadDos = ({ idunidad, index, productos }) => {
  let data = [...productos];
  let precio = 0.0;
  let montoiva = 0.0;
  let tipounidad = 0;
  let totalp = 0.0;
  let cantie = data[index].cantidadEA;
  let totales;
  let msm = {
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  };

  if (parseInt(idunidad) === parseInt(data[index].idunidadalterna)) {
    tipounidad = 1;
    cantie = parseFloat(data[index].cantidadEA);
    cantie = Math.trunc(cantie);

    if (parseInt(data[index].tipoprecio) === 1) {
      precio = parseFloat(data[index].precio) / data[index].valorfactor;
    }
  } else if (parseInt(idunidad) === parseInt(data[index].idunidadmedida)) {
    tipounidad = 0;
    cantie = parseFloat(data[index].cantidadEA / data[index].valorfactor);
    cantie = Math.trunc(cantie);

    if (parseInt(data[index].tipoprecio) === 1) {
      precio = parseFloat(data[index].precio * data[index].valorfactor);
    }
  }

  montoiva = (precio * parseFloat(data[index].iva)) / 100;
  montoiva = round(montoiva, 2);

  if (parseFloat(data[index].cantidad) > cantie) {
    data[index].cantidad = 1.0;
    msm = {
      mostrar: true,
      titulo: "Notificación",
      texto: "La  cantidad no debe ser mayor a la cantidad existente",
      icono: "informacion",
    };
  }

  data[index].tipounidad = tipounidad;
  data[index].precio = precio;
  data[index].unidad = data[index].unidad.reverse();
  data[index].total = precio * data[index].cantidad;
  data[index].montoiva = montoiva * data[index].cantidad;
  data[index].cantidadE = cantie;

  totales = calcularTotales(data);

  return {
    data,
    msm,
    totales,
  };
};

export const onCambioUnidadTres = ({ idunidad, index, productos }) => {
  let data = [...productos];
  let cantie = data[index].cantidad;
  let precio = 0.0;
  let montoiva = 0.0;
  let tipounidad = 0;
  let totales;
  let msm = {
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  };

  if (parseInt(idunidad) === parseInt(data[index].idunidadalterna)) {
    tipounidad = 1;
    precio = data[index].precio / data[index].valorfactor;
    cantie = parseFloat(data[index].cantidad);
    cantie = Math.trunc(cantie);
  } else if (parseInt(idunidad) === parseInt(data[index].idunidadmedida)) {
    tipounidad = 0;
    precio = data[index].precio * data[index].valorfactor;
    cantie = parseFloat(data[index].cantidad);
    cantie = Math.trunc(cantie);
  }

  montoiva = (precio * parseFloat(data[index].iva)) / 100;
  montoiva = round(montoiva, 2);

  data[index].tipounidad = tipounidad;
  data[index].precio = round(precio, 3);
  data[index].unidad = data[index].unidad.reverse();
  data[index].cantidad = cantie;
  data[index].totalsiniva = round(precio * cantie, 2);
  data[index].totalivas = round(montoiva * cantie, 2);
  data[index].totalmonto = round(precio * cantie + montoiva * cantie, 2);

  totales = calcularTotalesDos(data);

  return {
    data,
    msm,
    totales,
  };
};

export const validarCantidad = ({ index, event, productos, tipo = 2 }) => {
  let msm = {
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  };
  let data = [...productos];
  let totales;

  if (
    event.target.value === "" ||
    parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) ===
    0.0
  ) {
    event.target.value = "1,00";
  }
  event.target.value = formatoMonto(event.target.value);
  let char1 = event.target.value.substring(0, 1);
  let char2 = event.target.value.substring(1, 2);
  if (char1 === "0" && char2 !== ",") {
    event.target.value = event.target.value.substring(
      1,
      event.target.value.length
    );
  }
  let canti = parseFloat(
    event.target.value.replace(/\./g, "").replace(",", ".")
  );

  if (tipo !== 1 && data[index].servicio !== true) {
    if (canti > data[index].cantidadE) {
      data[index].cantidad = 1.0;
      canti = 1.0;
      if (data[index].cantidadE <= 0.0) {
        event.target.value = "0,00";
      } else {
        event.target.value = "1,00";
      }

      if (data[index].servicio !== true) {
        msm = {
          mostrar: true,
          titulo: "Notificación",
          texto: "La  cantidad no debe ser mayor a la cantidad existente",
          icono: "informacion",
        };
      }
    }
  }

  data[index].cantidad = canti;
  data[index].total = data[index].precio * canti;
  data[index].montoiva = (data[index].precio * canti * data[index].iva) / 100;
  totales = calcularTotales(data);

  return {
    data,
    msm,
    totales,
  };
};

export const validarCantidadForPedido = ({ index, event, productos, tipo = 2 }) => {
  let msm = {
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  };
  let data = [...productos];
  let totales;

  if (
    event.target.value === "" ||
    parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) ===
    0.0
  ) {
    event.target.value = "1,00";
  }
  event.target.value = formatoMonto(event.target.value);
  let char1 = event.target.value.substring(0, 1);
  let char2 = event.target.value.substring(1, 2);
  if (char1 === "0" && char2 !== ",") {
    event.target.value = event.target.value.substring(
      1,
      event.target.value.length
    );
  }
  let canti = parseFloat(
    event.target.value.replace(/\./g, "").replace(",", ".")
  );

  let moniv = (data[index].precio * data[index].iva) / 100;
  data[index].cantidad = canti;
  data[index].total = data[index].precio * canti;
  data[index].montoiva = round(moniv * canti, 2);
  totales = calcularTotales(data);

  return {
    data,
    msm,
    totales,
  };
};

export const validarCantidaDos = ({ index, event, productos, tipo = 2 }) => {
  let msm = {
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  };
  let data = [...productos];
  let totales;

  if (
    event.target.value === "" ||
    parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) ===
    0.0
  ) {
    event.target.value = "1,00";
  }
  event.target.value = formatoMonto(event.target.value);
  let char1 = event.target.value.substring(0, 1);
  let char2 = event.target.value.substring(1, 2);
  if (char1 === "0" && char2 !== ",") {
    event.target.value = event.target.value.substring(
      1,
      event.target.value.length
    );
  }
  let canti = parseFloat(
    event.target.value.replace(/\./g, "").replace(",", ".")
  );

  if (tipo !== 1) {
    if (canti > data[index].cantidadE) {
      data[index].cantidad = 1.0;
      canti = 1.0;
      if (data[index].cantidadE <= 0.0) {
        event.target.value = "0,00";
      } else {
        event.target.value = "1,00";
      }

      if (data[index].servicio !== true) {
        msm = {
          mostrar: true,
          titulo: "Notificación",
          texto: "La  cantidad no debe ser mayor a la cantidad existente",
          icono: "informacion",
        };
      }
    }
  }

  data[index].cantidad = canti;
  data[index].totalsiniva = round(data[index].precio * canti, 2);
  data[index].totalivas = round(
    (data[index].precio * parseFloat(data[index].iva) * canti) / 100,
    2
  );
  data[index].totalmonto = round(
    data[index].totalsiniva + data[index].totalivas,
    2
  );
  data[index].total = data[index].totalsiniva;
  data[index].totaldos = round(data[index].precioconiva * canti, 2);
  totales = calcularTotales_Dos(data);

  return {
    data,
    msm,
    totales,
  };
};

export const validarCantidaddos = ({ index, event, vacios, tipo = 2 }) => {
  let msm = {
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  };
  let data = [...vacios];
  let totales;

  if (
    event.target.value === "" ||
    parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) ===
    0.0
  ) {
    event.target.value = "0,00";
  }
  event.target.value = formatoMonto(event.target.value);
  let char1 = event.target.value.substring(0, 1);
  let char2 = event.target.value.substring(1, 2);
  if (char1 === "0" && char2 !== ",") {
    event.target.value = event.target.value.substring(
      1,
      event.target.value.length
    );
  }
  let canti = parseFloat(
    event.target.value.replace(/\./g, "").replace(",", ".")
  );

  if (tipo !== 1) {
    if (canti > data[index].cantidadE) {
      data[index].cantidad = 1.0;
      canti = 1.0;
      if (data[index].cantidadE <= 0.0) {
        event.target.value = "0,00";
      } else {
        event.target.value = "1,00";
      }

      msm = {
        mostrar: true,
        titulo: "Notificación",
        texto: "La  cantidad no debe ser mayor a la cantidad existente",
        icono: "informacion",
      };
    }
  }

  data[index].cantidad = canti;
  data[index].total = data[index].precio * canti;
  data[index].montoiva = (data[index].precio * canti * data[index].iva) / 100;
  totales = calcularTotales(data);

  return {
    data,
    msm,
    totales,
  };
};

export const validarCantidadTres = ({ index, event, productos }) => {
  let msm = {
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  };
  let data = [...productos];
  let totales;
  let montoiva = 0.0;
  let totalivas = 0.0;

  if (
    event.target.value === "" ||
    parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) ===
    0.0
  ) {
    event.target.value = "1,00";
  }

  event.target.value = formatoMonto(event.target.value);
  let char1 = event.target.value.substring(0, 1);
  let char2 = event.target.value.substring(1, 2);
  if (char1 === "0" && char2 !== ",") {
    event.target.value = event.target.value.substring(
      1,
      event.target.value.length
    );
  }
  let canti = parseFloat(
    event.target.value.replace(/\./g, "").replace(",", ".")
  );

  montoiva = (data[index].precio * parseFloat(data[index].iva)) / 100;

  let precio = round(data[index].precio, 2);

  data[index].cantidad = canti;
  data[index].totalsiniva = round(precio * canti, 2);
  data[index].totalivas = round(montoiva * canti, 2);
  data[index].totalmonto = round(
    data[index].totalsiniva + data[index].totalivas,
    2
  );
  totales = calcularTotalesDos(data);

  return {
    data,
    msm,
    totales,
  };
};

export const validarPrecioMontos = ({ index, event, productos, tipo = 2 }) => {
  let msm = {
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  };
  let data = [...productos];
  let totales;
  let montoiva = 0.0;

  if (
    event.target.value === "" ||
    parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) ===
    0.0
  ) {
    event.target.value = "1,00";
  }

  event.target.value = formatoMonto(event.target.value);
  let char1 = event.target.value.substring(0, 1);
  let char2 = event.target.value.substring(1, 2);
  if (char1 === "0" && char2 !== ",") {
    event.target.value = event.target.value.substring(
      1,
      event.target.value.length
    );
  }
  let preci = parseFloat(
    event.target.value.replace(/\./g, "").replace(",", ".")
  );

  montoiva = (preci * parseFloat(data[index].iva)) / 100;

  let precio = round(preci, 2);

  data[index].precio = preci;
  data[index].totalmonto = round(precio * data[index].cantidad + montoiva * data[index].cantidad, 2);
  data[index].totalivas = round(montoiva * data[index].cantidad, 2);
  data[index].totalsiniva = precio * data[index].cantidad;
  totales = calcularTotalesDos(data);

  return {
    data,
    msm,
    totales,
  };
};

export const validarMontos = (event) => {
  if (event.which === 13 || typeof event.which === "undefined") {
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(".", "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "1,00";
    }
    event.target.value = formatoMonto(event.target.value);
    let char1 = event.target.value.substring(0, 1);
    let char2 = event.target.value.substring(1, 2);
    if (char1 === "0" && char2 !== ",") {
      event.target.value = event.target.value.substring(
        1,
        event.target.value.length
      );
    }
    return event.target.value;
  } else if (event.which === 46) {
    return false;
  } else if (event.which >= 48 && event.which <= 57) {
    return true;
  } else if (event.which === 8 || event.which === 0 || event.which === 44) {
    return true;
  } else return false;
};

export const tipoprecio = {
  1: "MAXIMO",
  2: "OFERTA",
  3: "MAYOR",
  4: "MINIMO",
};

export const comboprecios = [
  { id: "1", nombre: "MAXIMO" },
  { id: "2", nombre: "OFERTA" },
  { id: "3", nombre: "MAYOR" },
  { id: "4", nombre: "MINIMO" },
];

export const formatBytes = (bytes, decimals = 2) => {
  if (!+bytes) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = [
    "Bytes",
    "KiB",
    "MiB",
    "GiB",
    "TiB",
    "PiB",
    "EiB",
    "ZiB",
    "YiB",
  ];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

/*
 * Usuarios con acceso al modulo de Auditoria (Configuracion General).
 * Se compara el login guardado en sessionStorage, igual que hace
 * public/index.html para autorizar las herramientas del navegador.
 */
export const USUARIOS_AUDITORIA = ["sistema", "gustavo"];

export const usuarioAuditoria = () => {
  try {
    const login = JSON.parse(sessionStorage.getItem("login") || "null");
    if (login === null || login === undefined) {
      return false;
    }

    return USUARIOS_AUDITORIA.indexOf(String(login).trim().toLowerCase()) >= 0;
  } catch (error) {
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/util/varios.js